export const sliceName = 'location'

export const locationAllRussiaContent = {
  name: 'Вся Россия',
  namePrepositional: 'Всей России',
  nameGenitive: 'Всей России',
}

export const locationType = 4
